"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLedgerTableError = exports.LEDGER_ERROR_FALLBACK = exports.PAYMENTS_DISABLED_MSG = void 0;
exports.PAYMENTS_DISABLED_MSG = 'This Project is not eligible for payments';
exports.LEDGER_ERROR_FALLBACK = 'Something went wrong';
// Surface the message provided by the server when present; otherwise use the generic fallback
const resolveLedgerTableError = (msg) => msg !== null && msg !== void 0 ? msg : exports.LEDGER_ERROR_FALLBACK;
exports.resolveLedgerTableError = resolveLedgerTableError;
//# sourceMappingURL=errorMessages.js.map